import config from 'config'
import allocationStore from 'modules/offer/stores/allocation'
import publisherStore from 'modules/offer/stores/publisher'
import pageStore from 'modules/path/stores/page'
import pathStore from 'modules/path/stores/path'
import pathUserProfileStore from 'modules/path/stores/user_profile'
import { LOADED, LOADING } from 'stores/BaseStore'
import alertStore from 'stores/alert'
import app from 'stores/app'
import HttpClient from 'utils/httpclient'

import BaseReportStore from './base-store'

export default new class BucketStore extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'bucket'

  publisher = this.attachEntity(publisherStore)
  path = this.attachEntity(pathStore)
  page = this.attachEntity(pageStore)
  allocation = this.attachEntity(allocationStore, { labelKey: 'description' })
  pathUserProfile = this.attachEntity(pathUserProfileStore)

  async fetchData({ startDate, endDate, groupby, sortby, metrics, filterby }) {
    try {
      this.collection.readyState = LOADING
      const { data } = await HttpClient.post(`${config.api}/reports/${this.entryPoint}`, {
        startDate: startDate.tz(app.timezone, true).format(),
        endDate: endDate.tz(app.timezone, true).format(),
        metrics,
        groupby,
        sortby,
        filterby,
        siteId: app.currentSiteID,
      })
      this.collection.data = data || null
      this.collection.readyState = LOADED
    } catch (e) {
      this.resetCollection()
      alertStore.error('Error', 'Unable to get results')
    }
  }
}
